export default "__VITE_ASSET__CIk9qL0M__"